import EventEmitter from 'eventemitter3';

import type { IConfirmProps } from './interface';

interface IConfirmEventProps {
  confirm: (params?: IConfirmProps) => void;
}

export const confirmModalEvent = new EventEmitter<IConfirmEventProps>();
